<template>
	<div>
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						:clearable="false"
						@commInput="setText"
						:propData="searchParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="searchMstList">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
			</template>
		</sf-search-layout>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
	</div>
</template>

<script>
// import { serviceMethods, serviceComputed } from '../../store/helpers';
// import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PartCkuPrvs/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import SearchInput from '@qms/Components/SearchInput';
import partMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchInput,
		partMngPopup
	},
	data() {
		return {
			commCdType: ''
		};
	},
	async created() {},
	methods: {
		...serviceMethods,
		...rootMethods,
		// setSearchParam({ key, value }) {
		// 	this.searchParams[key] = value;
		// },
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		sendData(param) {
			this.setSearchParam_({ key: 'partNo', value: param.partNo });
			//this.searchMstList();
		},
		async searchMstList() {
			try {
				this.schema.validateSync(this.searchParams);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}

			this.$sf_toggleLoading(true);
			await this.getPartCkuMstList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || error
					});
					//Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});

			// try {
			// 	this.$sf_toggleLoading(true);
			// 	await this.getPartCkuMstList_();
			// } catch (error) {
			// 	this.$sf_toast({
			// 		type: 'error',
			// 		message: error.message || error
			// 	});
			// } finally {
			// 	this.$sf_toggleLoading(false);
			// }
		},
		setText(param) {
			this.setSearchParam_(param);
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schema() {
			return yup.object().shape({
				partNo: yup //품번
					.string()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000956')])) //{0}은(는) 팔수 입력 값 입니다. , 품번
			});
		}
	}
};
</script>

<style></style>
